import Vue from 'vue'
import Router from 'vue-router'


//登录页
import login from '@/login/login.vue'
import WXLogin from '@/login/WXLogin.vue'

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/WXLogin',
      name: 'WXLogin',
      component: WXLogin
    },
    
    {
      path: "/",
      redirect: '/login'
    },
    {
      path: "*",
      redirect: '/login'
    }
  ]
});




export default router



// WEBPACK FOOTER //
// ./src/router/index.js